import { makeStyles } from "@material-ui/core";

export default function QuoteHeader(props) {
  const useStyles = makeStyles(() => ({
    container: {
      display: "flex",
      flexDirection: "column",
      alignContent: "center",
      flexWrap: "wrap",
      backgroundColor: "#F0F0F0",
      paddingBottom: 25,
      paddingTop: 15,
      fontFamily: `'Open Sans', sans-serif`,
    },
    header: {
      margin: "auto",
    },
    headerText: {
      textAlign: "center",
      marginBottom: 5,
      fontSize: 20,
      textTransform: "uppercase",
      lineHeight: 1.0,
      fontFamily: `'Open Sans', sans-serif`,
      fontWeight: 900,
    },
    headerName: {
      fontWeight: 500,
      letterSpacing: 1.8,
      marginBottom: 10,
    },
    imageView: {
      borderRadius: props.radius || 15,
      height: props.height || 200,
      width: props.width || 300,
      display: "block",
      margin: "0 auto", // This centers the image horizontally
    },
    yearly: {
      display: "flex",
      flexDirection: "row",
      alignContent: "center",
      margin: "auto",
    },
    sizeEstimate: {
      textTransform: "uppercase",
      color: "grey",
      textAlign: "center",
      margin: "auto",
    },
  }));

  const classes = useStyles();

  let label = "sq ft";
  if (props.measurementMode === "perimeter") {
    if (props.isMetric) {
      label = "LINEAR METERS";
    } else {
      label = "LINEAR FEET";
    }
  } else {
    if (props.isMetric) {
      label = "SQUARE METERS";
    } else {
      label = "SQUARE FEET";
    }
  }

  return (
    <div
      className={classes.container}
      id="quote-header-container"
      data-testid="quote-header-container"
    >
      <div
        className={classes.header}
        id="quote-header"
        data-testid="quote-header"
      >
        <div
          className={classes.headerText}
          id="quote-header-address"
          data-testid="quote-header-address"
        >
          {props.customerRecord.address || ""}
        </div>
        <div
          className={`${classes.headerText} ${classes.headerName}`}
          id="quote-header-customer-name"
          data-testid="quote-header-customer-name"
        >
          {props.customerRecord.name || ""}
        </div>
        {props.url !== null && (
          <img
            alt="home view"
            src={props.url}
            className={classes.imageView}
            id="quote-header-image"
            data-testid="quote-header-image"
          />
        )}
        <div
          className={classes.sizeEstimate}
          id="quote-header-size-estimate"
          data-testid="quote-header-size-estimate"
        >
          {props.sqft
            ? `${
                Number(props.sqft).toFixed(2).endsWith(".00")
                  ? Math.floor(Number(props.sqft))
                  : Number(props.sqft).toFixed(2)
              } ${label}`?.trim()
            : ""}
        </div>
      </div>
    </div>
  );
}
